import MuiDivider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

const Divider = styled(MuiDivider)(() => ({
  borderColor: 'var(--divider)',
}));

export default Divider;
